import { resetHeaderTheme } from 'Components/hooks/use-header-theme'
import makePubSubHook from 'Components/hooks/make-pub-sub-hook'

type SideNavStatus =
  | 'on' // 展开
  | 'off' // 收起
  | 'none' // 隐藏
  | 'fixed' // 固定加蒙层
  | 'md-none' // 1440 以下隐藏
  | 'md-off' // 1440 以下收起
  | 'lg-off' // 1680 以下收起

const defaultStatus: SideNavStatus = 'lg-off'

let pageType: string
export function setPageType(newPageType: string) {
  pageType = newPageType
  resetSideNavStatus()
  resetHeaderTheme()
}

export function getPageType() {
  return pageType
}

function getSideNavStatusByPageType(): SideNavStatus {
  if (!pageType) {
    return defaultStatus
  }
  if (pageType.indexOf('no-nav') > -1) {
    return 'none'
  }
  if (pageType.indexOf('auto-nav') > -1) {
    return 'md-none'
  }
  if (pageType.indexOf('lg-off-nav') > -1) {
    return 'lg-off'
  }
  return defaultStatus
}

const [setSideNavStatus, useSideNavStatus] =
  makePubSubHook<SideNavStatus>(defaultStatus)

export function resetSideNavStatus() {
  setSideNavStatus(getSideNavStatusByPageType())
}

export { setSideNavStatus }

export default useSideNavStatus
